import { useSelector } from 'react-redux';
import { useLDClient } from '@launchdarkly/react-sdk';
import { useEffect, useRef } from 'react';
import { buildLDContext } from './buildLDContext';
import { getLDEnv, isLDConfigured } from './ldConfig';

const LDAuthSync = () => {
  const isLoggedIn = useSelector((state) => state.authState.isLoggedIn);
  const userInfo = useSelector((state) => state.authState.userData?.data?.user_info);
  const client = useLDClient();
  const syncedUserKeyRef = useRef(null);

  useEffect(() => {
    if (!isLoggedIn) {
      // Clear so a later re-login as the same user_id (without an
      // intervening remount) doesn't bail out below on a stale match.
      syncedUserKeyRef.current = null;
      return;
    }
    if (!isLDConfigured()) {
      return;
    }
    const context = buildLDContext(userInfo, getLDEnv());
    if (!context || syncedUserKeyRef.current === context.key) {
      return;
    }
    syncedUserKeyRef.current = context.key;
    // Ordering (start before identify) empirically verified against
    // node_modules/@launchdarkly/js-client-sdk/dist/index.js (browser client
    // is constructed with `requiresStart: true`) and
    // node_modules/@launchdarkly/js-client-sdk-common/dist/cjs/index.cjs
    // (`identifyResult()` returns `{ status: 'error', error: new Error('Identify
    // called before start') }` when `_requiresStart && !this.startPromise`) —
    // see DFH-16510.
    client
      .start()
      .then(() => client.identify(context))
      .catch((error) => { console.error("error while syncing LaunchDarkly identity", error); });
  }, [isLoggedIn, userInfo?.user_id]);

  return null;
};

export default LDAuthSync;
